import React from "react";
import { FromXToYPromo, FromXToYPromoPrice } from "./FromXToYPromotion.styles";
import { PriceContent } from "../Price/PriceContent";

export function FromXToYPromotion({ product, styles, canvasScale, className }) {
  return (
    <FromXToYPromo
      styles={styles}
      canvasScale={canvasScale}
      className={`take-x-pay-y-span min-gap flex ${className || ""}`}
    >
      <div className="wrapper">
        <span className="de">De</span>
        <span className="normal-selling-price">
          R${product.normalSellingPrice.replace(".", ",")}
        </span>
        <span className="por">por</span>
      </div>
    </FromXToYPromo>
  );
}
